/**
 * Applies sum function to a column.
 * Non numerical values are skipped.
 * 
 * @param {any} data
 * @param {any} row
 * @param {any} col
 * @param {any} from
 * @param {any} to
 */
export default function (data, row, col, from, to) {
    from = from < 0 ? row + 1 : from;
    to = to < 0 ? data.length - 1 : to;

    let accumulator = 0;
    for (let r = from; r <= to; r++) {
        const value = data[r][col];
        if (typeof(value) !== "number") {
            continue;
        }
        accumulator += value;
    }

    return { value: accumulator };
}


// WEBPACK FOOTER //
// ./App/components/Handsontable/functions/colsum.js